import { services } from "../../../constants/services";
import { getByQuery } from "../../../utils/api";
import { IParamsRooms, ResponseQ } from "../../../common/dtos/paginate.dto";

export const GetRoomsService = async (params: IParamsRooms) => {
  const response = await getByQuery<ResponseQ<any>>(`${services.rooms}/rooms`, params);
  return response;
};